// extracted by mini-css-extract-plugin
export var bold = "_sj-0";